import { render } from "./main.layout.vue?vue&type=template&id=bc1ff748&scoped=true"
import script from "./main.layout.vue?vue&type=script&lang=js"
export * from "./main.layout.vue?vue&type=script&lang=js"

import "./main.layout.vue?vue&type=style&index=0&id=bc1ff748&scoped=true&lang=scss"

import exportComponent from "/usr/local/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bc1ff748"]])

export default __exports__